<template>
  <div id="page-companies">
    <h5 class="m-4">{{ $t('COMPANY.ALL_COMPANIES') }}</h5>

    <Confirm
      :title="$t('COMPANY.CONFIRM_DELETE')"
      :message="$t('COMPANY.CONFIRM_DELETE_MESSAGE')"
      ref="confirmModal"
      @cancel="cancelDelete"
      @confirm="confirmDelete"
    />

    <CompaniesTable
      @createCompanyClicked="createCompanyClicked"
      @selectCompanyClicked="selectCompanyClicked"
      @deleteCompanyClicked="deleteCompanyClicked"
    />
    <div class="scroll-to-container"></div>
    <b-card
      title=""
      class="mb-2 edit-company-container"
      ref="edit-company"
      id="edit-company"
      hide-footer
      v-if="creating || editing"
    >
      <div>
        <BasicCompanySettings
          :company_id="company_id"
          :company="company"
          :regions="regions"
        />
      </div>
    </b-card>
  </div>
</template>


<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import CompaniesTable from '@/view/pages/ml/companies/CompaniesTable.vue';
import BasicCompanySettings from '@/view/pages/ml/settings/BasicCompanySettings.vue';
import { DELETE_COMPANY } from '@/core/services/store/common.module';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

export default {
  name: 'companies',
  components: {
    CompaniesTable,
    BasicCompanySettings,
  },
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'periods'])
  },
  mixins: [ toasts ],
  mounted() {
    this.loadRegions();
  },
  data() {
    return {
      form: {
        company_id:      '',
        name: 	        '',
      },
      company_id: null,
      company: {},
      regions: {},
      creating: false,
      editing: false,
      regionOptions: []
    };
  },
  watch: {
    currentCompanyId(newValue, oldvalue) {
      
    }
  },
  methods: {
    createCompanyClicked() {},
    selectCompanyClicked(company_id) {
      this.company_id = company_id;
      
      axios 
        .get(`/company/admin?company_id=${this.company_id}`)
        .then(res => {
          this.company = res.data;
          this.editing = true;

          this.scrollToEditCompany();
        })
        .catch(err => {
          console.error(err);
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMPANY.UNABLE_GET'));
        });
    },
    deleteCompanyClicked(company_id) {
      axios 
        .delete(`/company/${company_id}`)
        .then(res => {

          this.$store.dispatch(DELETE_COMPANY, company_id);

          this.toastr('success', this.$t('COMMON.OK'), this.$t('COMPANY.DELETED'));

          if (res.data.update_hierarchy) {
            window.location.reload();
          }
        })
        .catch(err => {
          console.error(err);
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMPANY.UNABLE_DELETE'));
        });
    },
    getLangText(lang_text, lang) {
      for (var i = 0; i < lang_text.length; ++i) {
        if (lang_text[i].lang === lang) {
          return lang_text[i].text;
        }
      }

      return 'Språköversättning saknas';
    },
    scrollToEditCompany() {
      var that = this;
      setTimeout(function () {
        const el = that.$el.getElementsByClassName('scroll-to-container')[0];

        if (el) {
          const yOffset = -70;
          const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 100);
    },
    cancelDelete() {

    },
    confirmDelete() {

    },
    loadRegions() {
      axios
        .get('https://zip.memlist.se/api/v1/regions_communes')
        .then(res => {
          this.regions = res.data.regions;
          this.regionOptions = [];

          for (var k in this.regions) {
            this.regionOptions.push({ value: k, text: this.regions[k].region });
          }

          this.regionOptions.sort(function (a, b) {
            if (a.text < b.text) {
              return -1;
            }
            if (a.text > b.text) {
              return 1;
            }
            return 0;
          });
        })
        .catch(err => {
          console.error(err);
          this.toastr('danger', this.$t('COMMON.ERROR'), '');
        });
    },
    
  }
};
</script>
